import TableSettingModal from './TableSettingModal'

export default TableSettingModal
